/**
 * The built-in bath (defs/bath.ts) as a data spec: the bath plan symbol
 * (assets/bath.svg) traced into polylines at the default size. The shapes are
 * in one `stretch` group, so the symbol stretches with the footprint along
 * both axes — exactly like the built-in SVG glyph, which is normalized to
 * the footprint box.
 */

import { OBJECT_DEFINITION_SCHEMA_VERSION, type ObjectDefinitionSpec } from 'shared-types';
import bathSvg from '../../assets/bath.svg?raw';
import { svgSymbolShapes } from './svgSymbol';

const W = 1.7;
const D = 0.75;

const shapes = svgSymbolShapes('bath', bathSvg, W, D, 'bath', 'Bath');

export const bathSpec: ObjectDefinitionSpec = {
  schemaVersion: OBJECT_DEFINITION_SCHEMA_VERSION,
  anchor: 'POINT',
  constraint: { kind: 'FREE' },
  defaultSize: { width: W, depth: D, height: 0.6 },
  params: [],
  shapes,
  groups: [{ id: 'symbol', name: 'Bath symbol', shapeIds: shapes.map((s) => s.id), resize: { u: 'stretch', n: 'stretch' } }],
  model3d: null,
};
